import { Button } from '@/components/ui/Button';

type Props = {
  /** Pfad, zu dem nach erfolgreicher Anmeldung zurueckgekehrt wird (S-1). */
  ziel?: string;
};

export function LoginButton({ ziel }: Props) {
  return (
    <Button
      variant="primary"
      onClick={() => {
        // Das Ziel wird serverseitig am OAuth-State gespeichert und dort
        // gegen offene Redirects geprueft.
        const url =
          ziel !== undefined && ziel !== ''
            ? `/api/auth/login.php?ziel=${encodeURIComponent(ziel)}`
            : '/api/auth/login.php';
        window.location.assign(url);
      }}
    >
      Mit Nextcloud anmelden
    </Button>
  );
}
